import React from 'react';

import {
    View,
    Panel,
    PanelHeader,
    Group,
    List,
    Cell,
    FormItem,
    ButtonGroup,
    Textarea,
    ModalRoot,
    ModalPage, ModalPageHeader, PanelHeaderButton, Div, SplitLayout, SplitCol
} from '@vkontakte/vkui';

import {Button, FormLayout, FormLayoutGroup, Input} from '@vkontakte/vkui';
import CartApi from "./CartApi";
import IMask from "imask";
import axios from "axios";
import * as constants from "../assets/constants";
import {Icon24Cancel, Icon24Done} from "@vkontakte/icons";


class ChangePassForm extends React.Component {

    state = {
        username: '',
        email: '',
        text: '',
        usernameError: '',
        secureImage: '',
        secureCode: '',
        secureCodeError: '',
        odalHistory: [],
        activeModal: null,
    }

    constructor(props) {
        super(props);
        this.modalBack = () => {
            this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2])
        };
    }

    setActiveModal(activeModal) {
        activeModal = activeModal || null;
        let modalHistory = this.state.modalHistory ? [...this.state.modalHistory] : [];

        if (activeModal === null) {
            modalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            modalHistory = modalHistory.splice(0, modalHistory.indexOf(activeModal) + 1);
        } else {
            modalHistory.push(activeModal);
        }

        this.setState({
            activeModal,
            modalHistory
        });
    };


    onChange = (e, name) => {

        const val = e.target.value

        let data = {}

        data[name] = val

        this.setState(data)
    }

    getImage = () => {


        axios.get(this.props.base_url + '/?act=getCapcha')
            .then((response) => {

                if (response.data.image) {
                    this.setState({secureImage: response.data.image})
                }

            })
    }

    componentDidMount() {
        this.getImage()
    }

    render() {

        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>

                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_SEND_ORDER}
                           onClose={this.modalBack}

                           style={{
                               width: "100%", marginBottom: "100px"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Пароль будет сброшен
                               </ModalPageHeader>
                           }
                >
                    <Div><h1>Внимание!</h1>
                        <p>Новый пароль будет сброшен и отправлен на email <b>{this.state.email}</b></p>
                        <p>Продолжить?</p>
                    </Div>

                    <Div style={{marginBottom: '100px'}}>
                        <ButtonGroup mode="horizontal" stretched>
                            <Button before={<Icon24Done/>} size="l" stretched
                                    onClick={() => this.sendResetPass()}>Да</Button>
                            <Button before={<Icon24Cancel/>} size="l" stretched
                                    onClick={() => this.setActiveModal(null)}>Нет</Button>
                        </ButtonGroup>
                    </Div>
                </ModalPage>
            </ModalRoot>

        );

        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    <FormLayout title="Получить новый пароль">
                        <FormLayoutGroup>
                            <FormItem
                                status={this.state.usernameError ? 'error' : (this.state.username ? "valid" : "default")}
                                bottom={this.state.usernameError}>
                                <Input type="text" placeholder="Имя пользователя"
                                       onChange={e => this.onChange(e, 'username')}/>
                            </FormItem>
                            <FormItem
                                status={this.state.secureCodeError ? 'error' : (this.state.secureCode ? "valid" : "default")}
                                bottom={this.state.secureCodeError}>
                                <img src={this.state.secureImage} id="cph"/>
                                <Input type="text" placeholder="Введите код с картинки выше"
                                       onChange={e => this.onChange(e, 'secureCode')}/>
                            </FormItem>

                            <FormItem>
                                <ButtonGroup stretched>
                                    <Button onClick={() => this.goBack()} stretched mode="outline"
                                            size="l">Отмена</Button>
                                    <Button onClick={() => this.changePass()} stretched size="l">Сбросить
                                        пароль</Button>
                                </ButtonGroup>
                            </FormItem>
                        </FormLayoutGroup>
                    </FormLayout>
                </SplitCol>
            </SplitLayout>
        );
    }

    sendResetPass = () => {
        const body = new FormData()


        body.append("username", this.state.username)


        axios.post(this.props.base_url + '/?act=resetPassByLogin', body,
            {
                withCredentials: true

            }
        ).then((response) => {

            const data = response.data

            window.postMessage({type: data.indexOf('Пароль успешно сброшен') != -1 ? 'success' : 'error', text: data, timeout: 3000})


            if (data.indexOf('Пароль успешно сброшен') != -1) {
                this.setActiveModal(null)
                this.goBack()
            }
        })
    }

    changePass = () => {

        let errors_ = 0;

        this.setState(
            {
                usernameError: '',
                secureCodeError: '',
            })

        if (!this.state.username) {
            this.setState({usernameError: 'Необходимо логин'})
            errors_++;
        }

        if (!this.state.secureCode) {
            this.setState({secureCodeError: 'Необходимо указать код на картинке выше'})
            errors_++;
        }


        if (errors_ === 0) {

            const body = new FormData()


            body.append("sec", this.state.secureCode)


            axios.post(this.props.base_url + '/?act=checkCode', body,
                {
                    withCredentials: true

                }
            ).then((response) => {

                if (response.data.code == 1) {
                    body.delete('sec')
                    body.append("username", this.state.username)


                    axios.post(this.props.base_url + '/?act=getEmailByLogin', body,
                        {
                            withCredentials: true

                        }
                    ).then((response) => {
                        if (response.data.email) {
                            this.setState({email: response.data.email})
                            this.setActiveModal(constants.MODAL_SEND_ORDER)
                        } else {
                            this.setState({usernameError: 'Пользователь не найден'})
                        }
                    })


                } else {
                    this.getImage()
                    this.setState({secureCodeError: 'Код на картинке не совпадает'})
                }
            })
        }


    }
    goBack = () => {
        if (this.props.goBack) {
            this.props.goBack()
        }
    }
}

export default ChangePassForm

